import styled from "styled-components";

export const Container = styled.div``;

export const ContainerError = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 80vh;
`;

export const FooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin: 1rem 0;
	gap: 20px;

	> button {
		max-width: 200px;
	}
`;

export const GridWrapper = styled.div`
	&&& h6 {
		margin-left: 1rem;
		margin-top: 1rem;
	}
`;
